class OriginPoint {
  constructor(year, month = 6, day = 15) {
    this.year = year
    this.month = month
    this.day = day
    this.totalDays = (this.year * 365) + (this.month * 30) + this.day
  }

  diff(otherPoint) {
    return Math.abs(this.totalDays > otherPoint.totalDays ? this.totalDays - otherPoint.totalDays : otherPoint.totalDays - this.totalDays)
  }

}

export { OriginPoint }
